import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = { baseURL: siteConfig.siteUrl.API_URL };

const headers = () => ({
    Authorization: localStorage.getItem('access_token'),
    AuthId:        localStorage.getItem('id_token'),
});

// ── Catálogo ──────────────────────────────────────────────────────────────────
export function* getInsumos(action) {
    const query = action.query ? `?${action.query}` : '';
    const res = yield gaxios.request({ url: `api/inventario${query}`, headers: headers() });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({ type: actions.GET_INSUMOS_SUCCESS, payload: res.data.insumos });
    }
}

export function* getMercancias() {
    const res = yield gaxios.request({
        url: 'api/inventario?naturaleza=MERCANCIA',
        headers: headers(),
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({ type: actions.GET_MERCANCIAS_SUCCESS, payload: res.data.insumos });
    }
}

export function* createInsumo({ payload }) {
    const res = yield gaxios.request({
        url: 'api/inventario', method: 'POST', data: payload, headers: headers(),
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.CREATE_INSUMO_SUCCESS, payload: res.data.insumo });
    }
}

export function* editInsumo({ payload }) {
    const res = yield gaxios.request({
        url: `api/inventario/${payload._id}`, method: 'PUT', data: payload, headers: headers(),
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.EDIT_INSUMO_SUCCESS, payload });
    }
}

export function* deleteInsumo({ payload }) {
    const res = yield gaxios.request({
        url: `api/inventario/${payload}`, method: 'DELETE', headers: headers(),
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.DELETE_INSUMO_SUCCESS, payload });
    }
}

// ── Registro legado ───────────────────────────────────────────────────────────
export function* registroInventario({ payload }) {
    const res = yield gaxios.request({
        url: 'api/inventario/registro/', method: 'POST', data: payload, headers: headers(),
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.CREATE_INSUMO_SUCCESS, payload: res.data.insumo });
    }
}

export function* getRegistroInventario(action) {
    const query = action.query ? `?${action.query}` : '';
    const res = yield gaxios.request({
        url: `api/inventario/registro${query}`, headers: headers(),
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({ type: actions.GET_REGISTRO_SUCCESS, payload: res.data.inventario });
    }
}

// ── Movimientos ───────────────────────────────────────────────────────────────
export function* getMovimientos(action) {
    const query = action.query ? `?${action.query}` : '';
    try {
        const res = yield gaxios.request({
            url: `api/movimientos${query}`, headers: headers(),
        });
        if (!res.data.success) {
            notification('error', 'Error cargando movimientos');
        } else {
            yield put({
                type: actions.GET_MOVIMIENTOS_SUCCESS,
                payload: {
                    movimientos:    res.data.movimientos,
                    paginationInfo: res.data.paginationInfo,
                },
            });
        }
    } catch (err) {
        notification('error', 'Error cargando movimientos');
    }
}

// ── Stock actual ──────────────────────────────────────────────────────────────
export function* getStock(action) {
    const query = action.query ? `?${action.query}` : '';
    try {
        const res = yield gaxios.request({
            url: `api/movimientos/stock${query}`, headers: headers(),
        });
        if (!res.data.success) {
            notification('error', 'Error cargando stock');
        } else {
            yield put({
                type: actions.GET_STOCK_SUCCESS,
                payload: {
                    stock:                res.data.stock,
                    valorTotalInventario: res.data.valorTotalInventario,
                },
            });
        }
    } catch (err) {
        notification('error', 'Error cargando stock');
    }
}

// ── Alertas ───────────────────────────────────────────────────────────────────
export function* getAlertas() {
    try {
        const res = yield gaxios.request({
            url: 'api/movimientos/alertas', headers: headers(),
        });
        if (!res.data.success) {
            notification('error', 'Error cargando alertas');
        } else {
            yield put({ type: actions.GET_ALERTAS_SUCCESS, payload: res.data.alertas });
        }
    } catch (err) {
        notification('error', 'Error cargando alertas');
    }
}

// ── Ajuste manual ─────────────────────────────────────────────────────────────
export function* crearAjuste({ payload }) {
    try {
        const res = yield gaxios.request({
            url: 'api/movimientos/ajuste', method: 'POST', data: payload, headers: headers(),
        });
        if (!res.data.success) {
            notification('error', res.data.msg || 'Error al crear ajuste');
        } else {
            notification('success', res.data.msg || 'Ajuste registrado');
            yield put({ type: actions.CREAR_AJUSTE_SUCCESS });
            // Recargar stock después del ajuste
            yield put({ type: actions.GET_STOCK_REQUEST });
        }
    } catch (err) {
        notification('error', 'Error al crear ajuste');
    }
}

// ── Reporte de rotación ───────────────────────────────────────────────────────
export function* getRotacion(action) {
    const query = action.query ? `?${action.query}` : '';
    try {
        const res = yield gaxios.request({
            url: `api/movimientos/reporte/rotacion${query}`, headers: headers(),
        });
        if (!res.data.success) {
            notification('error', 'Error cargando reporte de rotación');
        } else {
            yield put({ type: actions.GET_ROTACION_SUCCESS, payload: res.data.rotacion });
        }
    } catch (err) {
        notification('error', 'Error cargando reporte de rotación');
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_INSUMOS_REQUEST,    getInsumos),
        takeEvery(actions.GET_MERCANCIAS_REQUEST,  getMercancias),
        takeEvery(actions.CREATE_INSUMO_REQUEST,   createInsumo),
        takeEvery(actions.EDIT_INSUMO_REQUEST,     editInsumo),
        takeEvery(actions.DELETE_INSUMO_REQUEST,   deleteInsumo),
        takeEvery(actions.SET_REGISTRO_INVENTARIO, registroInventario),
        takeEvery(actions.GET_REGISTRO_INVENTARIO, getRegistroInventario),
        takeEvery(actions.GET_MOVIMIENTOS_REQUEST, getMovimientos),
        takeEvery(actions.GET_STOCK_REQUEST,       getStock),
        takeEvery(actions.GET_ALERTAS_REQUEST,     getAlertas),
        takeEvery(actions.CREAR_AJUSTE_REQUEST,    crearAjuste),
        takeEvery(actions.GET_ROTACION_REQUEST,    getRotacion),
    ]);
}
